import * as React from 'react'

const Footer: React.FunctionComponent = () => {
  return (
    <div className="row">
      <div className="side-content"></div>
      <div className="main-content">
        <div className="content-header">
        </div>
        <div className="content-body">
          <p text-align="center">sWiZZleee 2019 &#169;</p>
        </div>
      </div>
      <div className="side-content"></div>
    </div>
  )
}

export default Footer
